import React from "react";
import Topbar from "../../../components/DashboardComponents/Topbar/Topbar";
// import EventPipeline from "../../../components/DashboardComponents/EventPipeline/EventPipeline";
// import InstitutionProfile from "../../../components/DashboardComponents/InstitutionProfile/InstitutionProfile";
// import UpcomingSessions from "../../../components/DashboardComponents/UpcomingSessions/UpcomingSessions";
// import LinkedMembers from "../../../components/DashboardComponents/LinkedMembers/LinkedMembers";
import StatCards from "../../../components/DashboardComponents/AuthorStatCards/StatCards";
import { useAuth } from "../../../context/AuthContext";
import styles from "../Dashboard.module.css";

const Dashboard = () => {
  
  const { userdata } = useAuth();
  return (
    <>
      <Topbar heading={ userdata.role === "author" ? " Research Associates" : userdata.role === "mentor" ?  "Mentors" : "" } />
      <div className={styles.stats}>
        <StatCards />
      </div>
      {/* <div className={styles.contentGrid}>
        <EventPipeline />
        <InstitutionProfile />
      </div>
      <div className={styles.bottomGrid}>
        <UpcomingSessions />
        <LinkedMembers />
      </div> */}
    </>
  );
};

export default Dashboard;
